<template>
  <div class="cq-page">
    <query-config
      :key="routeKey"
      :api="api"
      :mark="mark"
      :app-id="appId"
      :template-id="templateId"
      :edit-template-name="templateName"
      @execute="onExecute"
      @open-history="goHistory"
    />
  </div>
</template>

<script>
import queryConfig from '../views/query-config.vue'
import { getCustomQueryApi, ROUTE_NAMES, PAYLOAD_KEY, openRouteInNewTab } from '../runtime'

export default {
  name: 'custom-query-config-page',
  components: { queryConfig },
  data() {
    return {
      mark: '',
      templateId: '',
      templateName: '',
      // 用递增计数器作为子组件 key 的一部分，确保从编辑状态切回新建时强制重建
      keyCounter: 0,
      api: getCustomQueryApi()
    }
  },
  computed: {
    // 路由参数变化时改变 key，强制 query-config 重建以刷新内容
    routeKey() {
      return this.keyCounter + '_' + JSON.stringify(this.$route.query)
    }
  },
  created() {
    this.syncRouteQuery()
  },
  mounted() {
    // 兜底：浏览器复用标签页时可能不触发 beforeRouteUpdate（只聚焦不导航），
    // 监听 focus 事件检查 URL 参数是否变化，不一致则强制同步
    this._onFocus = () => {
      let q = this.$route.query
      let currentTplId = q.templateId || ''
      if (this.templateId !== currentTplId) {
        this.syncRouteQuery()
      }
    }
    window.addEventListener('focus', this._onFocus)
  },
  beforeDestroy() {
    window.removeEventListener('focus', this._onFocus)
  },
  // 复用标签页时路由参数可能变化，beforeRouteUpdate 处理同路由参数更新
  beforeRouteUpdate(to, from, next) {
    this.syncRouteQuery()
    next()
  },
  methods: {
    syncRouteQuery() {
      let oldTemplateId = this.templateId
      this.mark = this.$route.query.mark || ''
      this.appId = this.$route.query.appId || ''
      this.templateId = this.$route.query.templateId || ''
      this.templateName = this.$route.query.templateName || ''
      // 从编辑模式切到新建模式（templateId 有值 → 空），递增计数器强制子组件重建
      if (oldTemplateId && !this.templateId) {
        this.keyCounter++
      }
    },
    onExecute(payload) {
      // 用 localStorage 传参，保证在新开页面可读取
      localStorage.setItem(PAYLOAD_KEY, JSON.stringify(payload))
      openRouteInNewTab(this.$router, { name: ROUTE_NAMES.result, query: { mark: this.mark } })
    },
    goHistory() {
      openRouteInNewTab(this.$router, { name: ROUTE_NAMES.history, query: { mark: this.mark } })
    }
  }
}
</script>

<style lang="less" scoped>
.cq-page {
  min-height: 100%;
  background: #f0f2f5;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/custom-query/pages/config-page.vue